var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingCartActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.66124,
    cy: 20.9999,
    rx: 1.02062,
    ry: 1.02062,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.461,
    cy: 20.9999,
    r: 1.02062,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6001 5.85742L15.2632 5.88268L23.3961 5.93321L22.411 13.2578L21.0472 15.733L9.2773 15.8593L8.06489 13.5356L6.6001 5.85742Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.64062 22C10.1929 22 10.6406 21.5523 10.6406 21C10.6406 20.4477 10.1929 20 9.64062 20C9.08834 20 8.64062 20.4477 8.64062 21C8.64062 21.5523 9.08834 22 9.64062 22Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6406 22C21.1929 22 21.6406 21.5523 21.6406 21C21.6406 20.4477 21.1929 20 20.6406 20C20.0883 20 19.6406 20.4477 19.6406 21C19.6406 21.5523 20.0883 22 20.6406 22Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64062 1H5.64062L8.32062 14.39C8.41207 14.8504 8.66253 15.264 9.02817 15.5583C9.39381 15.8526 9.85132 16.009 10.3206 16H20.0406C20.5099 16.009 20.9674 15.8526 21.3331 15.5583C21.6987 15.264 21.9492 14.8504 22.0406 14.39L23.6406 6H6.64062",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.640625)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartActive);
export default __webpack_public_path__ + "static/media/shopping-cart-active.e417886a6bac9b4ed40c3791d632944c.svg";
export { ForwardRef as ReactComponent };